import actions from "./actions";

const initState = {
  users: null,
  user: null,
  roles: null,
  schools: null,
  grades: null,
  subjects: null,
  key: null,
  loading: false,
  status: "",
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.BULK_UPDATE_USERS:
      return {
        ...state,
        loading: true,
        status: "",
      };

    case actions.BULK_UPDATE_USERS_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };

    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
      };

    case actions.FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        user: action.user,
      };

    case actions.FETCH_CONFIGS_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        schools: action.schools,
        subjects: action.subjects,
        grades: action.grades,
      };

    case actions.CHANGE_STATUS_SUCCESS:
      const updatedUsers = state.users ? [...state.users] : [];
      const userIndex = updatedUsers.findIndex((user) => user._id === action.userId);
      if (userIndex > -1) {
        updatedUsers[userIndex] = {
          ...updatedUsers[userIndex],
          isActive: action.isActive,
        };
      }
      return {
        ...state,
        users: updatedUsers,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        users: null,
        user: null,
        key: null,
      };

    default:
      return state;
  }
}
